<template>
  <div>
    <div v-if="error">
      <server-error :error="error" />
    </div>
    <div v-if="isLoaded" data-cy="directories-page">
      <div class="pt-4 pb-4 px-6 b-section__title">
        <h1>{{$t('CONTENT.directories')}}</h1>
      </div>
      <ul class="px-6 b-tabs__list">
        <li class="b-tabs__list-item">
          <router-link
            class="b-tabs__list-item-link"
            :to="{name: 'Counterparty'}"
          > {{$t('CONTENT.counterparty.counterparty')}}
          </router-link>
        </li>
        <li class="b-tabs__list-item">
          <router-link
            class="b-tabs__list-item-link"
            :to="{name: 'Assets'}"
          > {{$tc('CONTENT.assets.asset', 2)}}
          </router-link>
        </li>
        <li class="b-tabs__list-item">
          <router-link
            class="b-tabs__list-item-link"
            :to="{name: 'Currency'}"
          > {{$t('CONTENT.currency.currency_rate')}}
          </router-link>
        </li>
        <li class="b-tabs__list-item">
          <router-link
            class="b-tabs__list-item-link"
            :to="{name: 'Payments'}"
          > {{$tc('CONTENT.payments.payment', 2)}}
          </router-link>
        </li>
        <li class="b-tabs__list-item">
          <router-link
            class="b-tabs__list-item-link"
            :to="{name: 'DiscountRates'}"
          > {{$t('CONTENT.discountRates.discount')}}
          </router-link>
        </li>
        <li class="b-tabs__list-item">
          <router-link
            class="b-tabs__list-item-link"
            :to="{name: 'Indexation'}"
          > {{$t('CONTENT.indexation.indexation')}}
          </router-link>
        </li>
      </ul>
      <div class="b-tabs">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      error: null
    };
  },
  async created() {
    try {
      this.error = null;
      this.$loadingManager.addLoadingStep();
      await Promise.all([
        this.$store.dispatch("getAllCounterparties"),
        this.$store.dispatch("getAllCounterpartyTypes"),
        this.$store.dispatch("getAllCounterpartyAddressTypes"),
        this.$store.dispatch("getAllDirectoryLegalForms"),
        this.$store.dispatch("loadAllAssets"),
        this.$store.dispatch("loadContractSettings"),
        this.$store.dispatch("loadAllUnderlyingAssetTypes"),
        this.$store.dispatch("loadAllBusinessUnits"),
        this.$store.dispatch("loadAllCurrencyCode"),
				this.$store.dispatch('loadAllPaymentTypes'),
        this.$store.dispatch("loadAllPaymentName"),
        this.$store.dispatch("loadAllPaymentKindsAndTypes")

      ]);
      this.$loadingManager.loadingStepLoaded();
    } catch (e) {
      this.$loadingManager.hideLoadScreen();
      this.error = e;
    }
  },
};
</script>
